import { timeFormatter } from '../formatters/time.formatter.js';
import { environment } from '../../../environment/environment.js';

export class DebugService {
  constructor(classname) {
    this.classname = classname ? `${classname}::` : classname;
    this.blnDebug = !environment.isProdEnv;
    this.blnHasConsole = false;
    this.defaultClassname = 'No Classname::';
  }

  log(pMessage, pObject) {
    if (this.classname === null || this.classname === undefined) {
      this.classname = this.defaultClassname;
    }
    if (this.blnDebug && this.checkForConsole()) {
      const timestr = timeFormatter();
      if (pObject !== null && pObject !== undefined) {
        console.info(this.classname, pMessage, pObject, timestr);
      } else {
        console.info(this.classname, pMessage, timestr);
      }
    }
  }

  checkForConsole() {
    this.blnHasConsole = true;
    try {
      console.log();
    } catch (er) {
      this.blnHasConsole = false;
    }
    return this.blnHasConsole;
  }
}
